import { useState } from "react";
import { message } from "antd";
import { v4 as uuidv4 } from "uuid";
import db from "../../../../database";
import { addProductToCart } from "../cart";
import { stock } from "../stock";
import { CheckoutTotalManualDiscount } from "../PricingRules/CheckoutTotalManualDiscount";
import { CheckoutFlatDiscount } from "../PricingRules/CheckoutFlatDiscount";
import { CheckoutPercentageDiscount } from "../PricingRules/CheckoutPercentageDiscount";
import { TotalBillDiscount } from "../PricingRules/totalBillDiscount";

const useProductAddons = ({
  cart,
  setCart,
  tillData,
  tillLayout,
  orderType,
  isExchange,
  selectedProductInCart,
  setSelectedProductInCart,
  deleteCart,
  processTotalManualDiscount,
  setLoader,
  salesRepresentDefaultLine,
  cartRef,
  productsCopy,
  salesRepresent,
  processBillDiscounts,
  setSelectedRowKeys,
  setOrderTimeDetails,
  setDisplayAddOnSelection,
  displayAddOnSelection,
  manualDiscountTypes,
  setProductStock,
  setProductBOMStock,
  setProductBOMStockData,
  setTableCards,
  dispatchItemSelection,
  searchInputRef,
  setShowCompleteSaleStock,
  setCompleteSaleStockData,
  setManualDiscountInput,
  setSelectedManualDiscountTypeValue,
  removeAllDiscounts,
  setSelectedPaymentMethod,
  selectedReturnType,
  setFilterDrawer,
}) => {
  const [addOnsList, setAddOnsList] = useState({
    requiredList: [],
    optionsList: [],
  });
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [isUpdatingAddon, setIsUpdatingAddon] = useState(false);
  const [copyKOTVisible, setCopyKOTVisible] = useState(false);
  const [groupedFiredItems, setGroupedFiredItems] = useState({});
  const [selectedCopyItems, setSelectedCopyItems] = useState({});
  const [selectedProduct, setSelectedProduct] = useState({});

  const addDefinedProductWithAddons = (productObjs, upc, batchno, mBatchId, price, addonWeightFlag) => {
    const productObj = { ...productObjs };
    if (productObj.overRideTax === "Y" && price <= productObj.overRideCondition) {
      const originalPrice = price - (price - price * (100 / (100 + productObj.taxRate)));
      const taxedPrice = originalPrice + (originalPrice * productObj.contraRate) / 100;
      price = taxedPrice;
      productObj.cTaxId = productObj.contraTaxId;
      productObj.taxRate = productObj.contraRate;
    }
    productObj.salePrice = productObj?.sunitprice || 0;
    productObj.realPrice = price;
    productObj.order = "N";
    ((productObj.isQtyDesimal = productObj?.uomData?.[0]?.stdprecision ?? 2), (productObj.productId = productObj?.mProductId || null));
    productObj.mBatchId = mBatchId || null;
    productObj.productId = productObjs.productId;
    productObj.selectedAddons = productObj.selectedAddons.map((addon) => ({
      ...addon,
      weight: addonWeightFlag ? (addon.weight ?? 1) : (addon.weight ?? 0) + 1,
    }));
    addProductToCart(
      productObj,
      productObj.weight || productObj?.qty,
      false,
      cart,
      setCart,
      setSelectedProductInCart,
      deleteCart,
      processTotalManualDiscount,
      setLoader,
      salesRepresentDefaultLine,
      tillData,
      cartRef,
      productsCopy,
      salesRepresent,
      orderType,
      processBillDiscounts,
      undefined,
      setSelectedRowKeys,
      setOrderTimeDetails,
      setDisplayAddOnSelection,
      displayAddOnSelection,
      handleAddOnModal,
      manualDiscountTypes,
      CheckoutFlatDiscount,
      CheckoutPercentageDiscount,
      CheckoutTotalManualDiscount,
      setProductStock,
      selectedProductInCart,
      setTableCards,
      dispatchItemSelection,
      searchInputRef,
      false,
      setShowCompleteSaleStock,
      setCompleteSaleStockData,
      TotalBillDiscount,
      tillLayout,
      false,
      setManualDiscountInput,
      setSelectedManualDiscountTypeValue,
      removeAllDiscounts,
      setSelectedPaymentMethod,
      selectedReturnType,
      false,
      setProductBOMStock,
      setProductBOMStockData
    );
    setSelectedAddons([]);
  };

  const handleAddOnModal = (record, event) => {
    setSelectedProduct(record);
    setDisplayAddOnSelection(true);
    const requiredListFilter = [...record.productAddons].filter((item) => Number(item.mAddonGroup?.minqty || 0) >= 0);
    const optionsListFilter = [...record.productAddons].filter((item) => Number(item.mAddonGroup?.minqty || 0) === 0);
    setAddOnsList({
      requiredList: requiredListFilter || [],
      optionsList: optionsListFilter || [],
    });
  };

  const handleAddOnValue = (e, fieldName) => {
    let newSelectedAddons = [...selectedAddons];
    const indexValue =
      fieldName === "addOnRadio"
        ? newSelectedAddons.findIndex((item) => item.mAddonGroup.mAddonGroupId === e.target.value.mAddonGroup.mAddonGroupId)
        : newSelectedAddons.findIndex((item) => item === e.target.value);
    if (indexValue !== -1) {
      if (e.target.checked) {
        newSelectedAddons[indexValue] = e.target.value;
      } else {
        newSelectedAddons.splice(indexValue, 1);
      }
    } else {
      newSelectedAddons = [...selectedAddons, e.target.value];
    }
    const selectedAddonsWithWeight = {
      ...newSelectedAddons,
      weight: 1,
    };
    setSelectedAddons(newSelectedAddons);
  };

  const handleQty = (fieldName) => {
    let newSelectedProduct = {
      ...selectedProduct,
      weight: selectedProduct?.weight || 1,
    };
    if (fieldName === "plus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) + 1;
    }
    if (fieldName === "minus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) - 1;
      if (newSelectedProduct.weight <= 1) {
        newSelectedProduct.weight = 1;
      }
    }
    setSelectedProduct({
      ...newSelectedProduct,
    });
  };

  const handleCopyKOT = async () => {
    const firedItems = cart.items.filter((item) => Number(item.firedQty) > 0 && item.order === "Y");

    if (firedItems.length === 0) {
      message.info("No valid fired items (with order = 'Y') to copy KOT.");
      return;
    }

    const clones = firedItems.map((item) => {
      const qty = Number(item.firedQty);

      // Deep clone (to avoid reference linking)
      const clone = structuredClone ? structuredClone(item) : JSON.parse(JSON.stringify(item));

      // Assign a new lineId (very important)
      clone.lineId = uuidv4().replace(/-/g, "").toUpperCase();

      // New item → should not be fired
      clone.order = "N";
      clone.firedQty = 0;
      clone.sendQty = 0;

      // Set quantity equal to firedQty
      clone.weight = qty;

      return clone;
    });

    const mergedCart = {
      ...cart,
      items: [
        ...cart.items, // keep original items
        ...clones, // add copies (one per fired item)
      ],
    };

    if (navigator.onLine) {
      const stockCheckResult = await stock({
        cart: mergedCart,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation: false,
        setTempCart: () => {},
        isCompleteSale: false,
        setShowCompleteSaleStock,
        setCompleteSaleStockData,
        customMixHandler: false,
        setProductBOMStock,
        setProductBOMStockData,
      });
      if (!stockCheckResult) {
        return;
      }
    }

    if (!isExchange) {
      setCart(mergedCart);
    }
    message.success("Copied KOT items added!");
  };

  const openCopyKOTModal = async () => {
    const firedItems = cart.items.filter((item) => Number(item.firedQty) > 0 && item.order === "Y");

    if (firedItems.length === 0) {
      message.info("No fired items to copy.");
      return;
    }

    // Load category list from DB
    const categories = await db.productCategories.toArray();

    // Map categoryId -> categoryName
    const categoryMap = {};
    categories.forEach((cat) => {
      categoryMap[cat.mProductCategoryId] = cat.name;
    });

    // Group fired items by category, unique by productId
    const grouped = firedItems.reduce((acc, item) => {
      const categoryName = categoryMap[item.mProductCategoryId] || "Others";

      if (!acc[categoryName]) acc[categoryName] = [];

      // Prevent same product appearing multiple times
      if (!acc[categoryName].some((x) => x.productId === item.productId)) {
        acc[categoryName].push(item);
      }

      return acc;
    }, {});

    setGroupedFiredItems(grouped);
    setSelectedCopyItems({});
    setCopyKOTVisible(true);
  };

  const handleAdd = async () => {
    await addDefinedProductWithAddons(
      {
        ...selectedProduct,
        sProductID: uuidv4().replace(/-/g, "").toUpperCase(),
        selectedAddons: selectedAddons || [],
      },
      selectedProduct.upc,
      null,
      null,
      selectedProduct.sunitprice,
      false
    );
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
    setFilterDrawer(false);
  };

  const handleAddOnModalClose = () => {
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
  };

  return {
    // State
    addOnsList,
    setAddOnsList,
    selectedAddons,
    setSelectedAddons,
    isUpdatingAddon,
    setIsUpdatingAddon,
    copyKOTVisible,
    setCopyKOTVisible,
    groupedFiredItems,
    setGroupedFiredItems,
    selectedCopyItems,
    setSelectedCopyItems,
    selectedProduct,
    setSelectedProduct,
    // Handlers
    addDefinedProductWithAddons,
    handleAddOnModal,
    handleAddOnValue,
    handleQty,
    handleCopyKOT,
    openCopyKOTModal,
    handleAdd,
    handleAddOnModalClose,
  };
};

export default useProductAddons;
